module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "blue",
      "data-image": "../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RAEFTON")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_dashboard"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item active "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_createrfq"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "/raw_templates/t_contacts"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(/static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo"
    }
  }, [_vm._v("Create RFQ")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card-columns"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Customer")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_co"
    }
  }, [_vm._v("Company / Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "customer_co",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_co"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "customer_terms"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("EXW Ex-works")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_co"
    }
  }, [_vm._v("Due Date")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "datetimepicker",
      "type": "text"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      86 Edwin Street\n                      "), _c('br'), _vm._v(" Kitchener, Ontario\n                      "), _c('br'), _vm._v(" K0A 2N0\n                      "), _c('br'), _vm._v(" Canada\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipper")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "shipper_co"
    }
  }, [_vm._v("Company / Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "shipper_co",
      "placeholder": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "datetimepicker"
    }
  }, [_vm._v("Pick Up")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "datetimepicker",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "shipper_appt"
    }
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "shipper_appt"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      86 Edwin Street\n                      "), _c('br'), _vm._v(" Kitchener, Ontario\n                      "), _c('br'), _vm._v(" K0A 2N0\n                      "), _c('br'), _vm._v(" Canada\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Assignees")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("John Valence")]), _vm._v(" "), _c('td', [_vm._v("11/02/2018")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-danger"
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "assignee_name"
    }
  })])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "datetimepicker",
      "type": "text"
    }
  })])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-success"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Consignee")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "consignee_co"
    }
  }, [_vm._v("Company / Name")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "consignee_co",
      "placeholder": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "datetimepicker"
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control datetimepicker",
    attrs: {
      "id": "datetimepicker",
      "type": "text"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_co"
    }
  }, [_vm._v("Appointment")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "customer_terms"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customer_co"
    }
  }, [_vm._v("COD")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "customer_terms"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("No")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "rolodex"
  }, [_vm._v("\n                      86 Edwin Street\n                      "), _c('br'), _vm._v(" Kitchener, Ontario\n                      "), _c('br'), _vm._v(" K0A 2N0\n                      "), _c('br'), _vm._v(" Canada\n                    ")])])])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Truck")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_trailertype"
    }
  }, [_vm._v("Trailer Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_trailertype"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_suspensiontype"
    }
  }, [_vm._v("Suspension Type")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_suspensiontype"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_temperaturecontrol"
    }
  }, [_vm._v("Temperature Control")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_temperaturecontrol"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_liftgate"
    }
  }, [_vm._v("Lift Gate")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_liftgate"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_driverassist"
    }
  }, [_vm._v("Driver Assist")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_driverassist"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_mode"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_mode"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_service"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_service"
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-4 col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_trailertype"
    }
  }, [_vm._v("Dunnage Required")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "truck_special"
    }
  }, [_vm._v("Special Instructions")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "truck_special",
      "id": "truck_special",
      "cols": "30",
      "rows": "10"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "alert alert-warning text-center d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('h4', {
    staticClass: "m-0"
  }, [_c('span', {
    staticClass: "small text-white"
  }, [_vm._v("Density")]), _vm._v(" "), _c('strong', {
    staticClass: "pr-4"
  }, [_vm._v("160 lbs / cubic ft")]), _vm._v(" "), _c('span', {
    staticClass: "small text-white"
  }, [_vm._v("Class")]), _vm._v(" "), _c('strong', [_vm._v("75")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Unit")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "disabled-sorting"
  }), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Width")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Height")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting"
  }, [_vm._v("Unit")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting"
  }, [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Stackable")]), _vm._v(" "), _c('th', [_vm._v("Hazardous")]), _vm._v(" "), _c('th', {
    staticClass: "disabled-sorting text-right"
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("#1")]), _vm._v(" "), _c('td', [_vm._v("lorem ipsum dolor sit amet")]), _vm._v(" "), _c('td', [_vm._v("Skid")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("48")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("48")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("48")]), _vm._v(" "), _c('td', [_vm._v("Inches")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("1000")]), _vm._v(" "), _c('td', [_vm._v("lbs")]), _vm._v(" "), _c('td', [_vm._v("Yes")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('td', {
    staticClass: "nowrap text-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-success",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("#2")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "shipping_type"
    }
  }, [_c('option', [_vm._v("None")]), _vm._v(" "), _c('option', [_vm._v("Pallet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Skid",
      "selected": "selected"
    }
  }, [_vm._v("Skid")]), _vm._v(" "), _c('option', [_vm._v("Slipsheet")]), _vm._v(" "), _c('option', [_vm._v("Tote")]), _vm._v(" "), _c('option', [_vm._v("Pallet Box")]), _vm._v(" "), _c('option', [_vm._v("Skid Box")]), _vm._v(" "), _c('option', [_vm._v("Bin")]), _vm._v(" "), _c('option', [_vm._v("Basket")]), _vm._v(" "), _c('option', [_vm._v("Rack")]), _vm._v(" "), _c('option', [_vm._v("Carton")]), _vm._v(" "), _c('option', [_vm._v("Bag")]), _vm._v(" "), _c('option', [_vm._v("Drum")]), _vm._v(" "), _c('option', [_vm._v("Crate")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "suunitlength"
    }
  }, [_c('option', [_vm._v("Inches")]), _vm._v(" "), _c('option', [_vm._v("Millimeters")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "suunitweight"
    }
  }, [_c('option', [_vm._v("Pounds")]), _vm._v(" "), _c('option', [_vm._v("Grams")])])]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "shipping_stackable"
    }
  }, [_c('option', {
    attrs: {
      "id": "stackabledefault"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])]), _vm._v(" "), _c('td', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "shipping_hazardous"
    }
  }, [_c('option', {
    attrs: {
      "id": "stackabledefault"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('option', [_vm._v("Yes")])])]), _vm._v(" "), _c('td', {
    staticClass: "nowrap text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn btn-simple btn-link btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save")])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64f7b058"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_createrfq.vue
// module id = 724
// module chunks = 0